module.exports = __webpack_public_path__ + "img/notif-email.de0226aa.svg";